import { BigNumber } from 'ethers'
import { Token } from '../model'

export function shortenAddress(account: string) {
  return account.substring(0, 6) + '...' + account.substring(account.length - 4)
}

export function areTokensSorted(tokenA: Token, tokenB: Token) {
  return BigNumber.from(tokenA.address).lt(BigNumber.from(tokenB.address))
}

export function sortTokens(tokenA: Token, tokenB: Token) {
  return areTokensSorted(tokenA, tokenB) ? [tokenA, tokenB] : [tokenB, tokenA]
}
